var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#F5F4ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2C17.1897 2 19.3439 2.55311 21.2628 3.60801C23.1817 4.66291 24.803 6.18542 25.9763 8.03425L15 15V2Z",
    fill: "#CDC6A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuess);
export default __webpack_public_path__ + "static/media/guess.a8a21bd3e67eb725a9565be0f9862a65.svg";
export { ForwardRef as ReactComponent };